import {Toast, ToastPosition, ToastProps, ToastType} from './Toast'
import {ToastContext} from './ToastContext'
import {Accessor, createSignal, For, Setter} from 'solid-js'
import {useDispatch} from '../../store'
import {removeNotificationById} from '@te_react/volt-store/lib/actions'

export interface ToastProviderProps {
    toastPosition?: ToastPosition
    children: any
}

export const ToastProvider = (props: ToastProviderProps) => {
    const [autoClosed, setAutoClosed] = createSignal<boolean>(false)
    const [toastDetails, setToastDetails] = createSignal<ToastProps[]>([])
    const [toastsMarkedForDeletion, setToastsMarkedForDeletion] = createSignal<number[]>([])
    const dispatch = useDispatch()
    const timeoutHandle: any = {}

    const clearTimeOutHandler = (id: any) => {
        if (id in timeoutHandle) {
            clearTimeout(timeoutHandle[id])
            delete timeoutHandle[id]
        }
    }
    const setTimeoutHandler = (id: any, code: any, time: any) => {
        clearTimeOutHandler(id)
        timeoutHandle[id] = setTimeout(code, time)
    }

    const autoCloseToast = (id: number, popUpId: any, life: number = 5000) => {
        setTimeoutHandler(id, () => {
            onToastClose(id, popUpId)
        }, life)
    }

    const showToast = (toast: ToastProps | ToastProps[]) => {
        if (Array.isArray(toast)) {
            const newToasts: ToastProps[] = toast.map((t: ToastProps) => {
                const id = new Date().getTime()
                !t.sticky && autoCloseToast(id, t.id, t.life)
                return {...t, description: t.description, id}
            })

            setToastDetails([...toastDetails(), ...newToasts])
        } else {
            const toastDetail = toastDetails().find(toast => toast.title === "NO_INTERNET") 
            if(toastDetail) return
            const id = new Date().getTime()
            !toast.sticky && autoCloseToast(id, toast.id, toast.life)
            setToastDetails([...toastDetails(), {...toast, description: toast.description, id}])
        }
    }

    const onToastClose = (id: number, popUpId?: number) => {
        setToastsMarkedForDeletion([...toastsMarkedForDeletion(), id])
        clearTimeOutHandler(id)
        setTimeout(() => {
            const toasts = [...toastDetails()]
            toasts.splice(
                toastDetails().findIndex(t => t.id === id),
                1
            )
            setToastDetails(toasts)

            const toastDeletion = [...toastsMarkedForDeletion()]
            toastDeletion.splice(
                toastDeletion.findIndex(t => t === id),
                1
            )
            setToastsMarkedForDeletion(toastDeletion)
            dispatch(removeNotificationById(popUpId))
        }, 500)
    }

    return (
        <ToastContext.Provider value={{show: showToast}}>
            {props.children}
            <For each={toastDetails()}>
                {(toast: ToastProps, index) => {
                    return (
                        <Toast
                            {...toast}
                            position={props.toastPosition}
                            index={index()}
                            className={toastsMarkedForDeletion().includes(toast.id || 0) ? 'deletion' : ''}
                            onClose={(id) => onToastClose(id)}
                            autoClosed={autoClosed()}
                            setAutoClosed={setAutoClosed}
                        />
                    )
                }}
            </For>
        </ToastContext.Provider>
    )
}

export interface ToastProviderBehavior {
    show: (toast: ToastProps) => any,
}
